import { fromJS } from 'immutable';
import {
	FETCH_GLOBAL_SEARCH_SUCCESS,
	FETCH_GLOBAL_SEARCH_ERROR
} from '../constants/actionTypes';
import * as K from "../constants/constants";

const initialState = fromJS([]);

export function globalSearchResults(state = initialState, {type, payload}) {

	if ( type === FETCH_GLOBAL_SEARCH_SUCCESS ) {
		// payload.expires = new Date().setUTCHours( K.HOURS_BEFORE_EXPIRE );
		let key = payload.get("id");

		// Replace the current expired data with the new one
		// Expiration control is handled in the selector
		if( state.has(key) ) {
			state.update(key, payload );
		}

		return state.push( payload ); // NB! The new data is added to the store object as previous results are being cached.
	} else if(type === FETCH_GLOBAL_SEARCH_ERROR) {
		return state;
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/js/reducers/globalSearchResults.js